import { Component, OnInit, Input , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-payment-notify-popup',
    templateUrl: './payment-notify-popup.component.html',
    styleUrls: ['./payment-notify-popup.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class PaymentNotifyPopupComponent implements OnInit {
    @Input() messages: any[] = [];
    @Input() buttons: any[] = [];
    @Input() icon?: any = {};
    // list selected application id
    @Input() applicationId?: string;
    @Input() type?: string;

    buttonArray: any[] = [];

    constructor(private modalController: ModalController, private navCtrl: NavController) {}

    ngOnInit() {/* empty */}

    dismiss() {
        this.modalController.dismiss();
    }

    goToPreApprovedApplication() {
        this.dismiss();
        this.navCtrl.navigateRoot(['/application/' + this.applicationId]);
    }

    ctaClick(type: string) {
        if (type === 'submit') {
            this.modalController.dismiss({
                success: true,
            });
        } else if (type === 'confirm-delete') {
            this.modalController.dismiss(true);
        } else if (type === 'view-pending-wire') {
            this.modalController.dismiss(false);
            this.navCtrl.navigateForward(['/wire-transfer-details']);
        } else if (type === 'cancel-select') {
            this.modalController.dismiss(false);
        } else {
            this.modalController.dismiss(false);
        }
    }
}
